// extracted by mini-css-extract-plugin
export default {"primaryBtn":"PrimaryButton_primaryBtn__w1tgF","negative":"PrimaryButton_negative__qWuwu","positive":"PrimaryButton_positive__euSNT"};